jQuery(function ($) {
    $(document).ready(function() {
        //open mobile menu 
        const menuIcon = $('[data-nav-menu-toggle]');
        const menu = $('[data-nav-menu-mobile]');

        menuIcon.on('click', function(e) {
            e.preventDefault();
            menu.toggleClass('open');

            if (menu.hasClass('open')) {
                $('body, html').css('overflow', 'hidden'); //dont allow scrolling the body if menu is open
            } else {
                $('body, html').attr('style', ''); //allow scrolling the body again
            }
        });

        // don't follow the link in de main nav if it has children
        $('.menu-item-has-children .nav-main-link-level-1').on('click',function(e) {
            e.preventDefault();
        });


        // user pointerenter instead of mouseenter so we can check if it's a mouse event or a touch event. 
        // Otherwise it will conflict with the click event.
        /*
        $('.menu-item-has-children').on('pointerenter',function(e) {
            if (e.pointerType === 'mouse') {
                $(this).addClass('dropdown-open');
            }
        });

        $('.menu-item-has-children').on('mouseleave',function(e) {
            $(this).removeClass('dropdown-open');
        });

        $('.menu-item-has-children').on('click',function() {
            $(this).toggleClass('dropdown-open');
        });
        */
    });
});